// @flow

import { observable, action } from "mobx"
import qs from "qs"

class ApiVersionStore {
  @observable apiVersion: string = localStorage.getItem("apiVersion") || "api"

  @action
  setApiVersion: () => void = () => {
    const urlParams = qs.parse(window.location.search.substring(1))
    const apiVersion = urlParams.api
    if (apiVersion && (apiVersion === "api" || apiVersion === "api2")) {
      localStorage.setItem("apiVersion", apiVersion)
      this.apiVersion = apiVersion
    }
  }
}

export default (new ApiVersionStore(): ApiVersionStore)
